// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// Define a service using a base URL and expected endpoints
export const bookingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllBookings: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `bookings?${queryString}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 300, // Cache for 5 minutes
    }),
    refundBooking: builder.mutation({
      query: (id) => {
        return {
          url: `bookings/refund/${id}`,
          method: "PUT",
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllBookingsQuery, useRefundBookingMutation } = bookingApi;
